import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';

// Router
import { getRoute } from '../../entry/routes';

// Components
import Heading from '../Heading';
import Button from '../Button';

// Icons
import cover from './assets/cover.png';

// Styles
import styles from './CreatePizzaCard.styl';

const cx = classNames.bind(styles);

export default function CreatePizzaCard(props) {
  const { className, id, name } = props;
  const { isPhone } = useSelector(state => state.responsive);

  return isPhone ? (
    <Link to={getRoute('constructorAlias', id)} className={cx('CreatePizzaCardPhone', className)}>
      <div className={cx('CreatePizzaCardPhone__body')}>
        <Heading className={cx('CreatePizzaCardPhone__heading')} level={3}>
          {name}
        </Heading>
        <Button className={cx('CreatePizzaCardPhone__button')} secondary small>
          <FormattedMessage id="button.createPizza" />
        </Button>
      </div>
      <LazyLoadImage className={cx('CreatePizzaCardPhone__image')} src={cover} alt={name} />
    </Link>
  ) : (
    <div className={cx('CreatePizzaCard', className)}>
      <Heading className={cx('CreatePizzaCard__heading')} level={3}>
        {name}
      </Heading>
      <LazyLoadImage className={cx('CreatePizzaCard__picture')} alt={name} src={cover} />

      <Button
        className={cx('CreatePizzaCard__button')}
        to={getRoute('constructorAlias', id)}
        secondary
      >
        <FormattedMessage id="button.createPizza" />
      </Button>
      <div className={cx('CreatePizzaCard__note')}>
        <FormattedMessage id="constructor.slogan" />
      </div>
    </div>
  );
}

CreatePizzaCard.defaultProps = {
  className: '',
};

CreatePizzaCard.propTypes = {
  className: PropTypes.string,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};
